import { controls,grouped } from "../controls";
const customer_kpis = {
label: "Customer Kpis",
pageLabel: "Customer Kpis",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.magicDateLabel({ tab: "filter", label: "Kyc Due Date",target: "kyc_due_date"}),
...controls.magicDate({ tab: "filter", name: "kyc_due_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:false, label: "Kyc Flag", name: "kyc_flag" }),
...controls.displayText({ tab: "filter", label: "Kyc Desc"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "kyc_desc",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Risk Category Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "risk_category_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Customer Category Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "customer_category_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:false, label: "Sign Flag", name: "sign_flag" }),
...controls.magicDateLabel({ tab: "filter", label: "Sign Date",target: "sign_date"}),
...controls.magicDate({ tab: "filter", name: "sign_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Sign Count"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "sign_count",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.magicDateLabel({ tab: "general", label: "Kyc Due Date",target: "kyc_due_date",star:true}),
...controls.magicDate({ tab: "general", name: "kyc_due_date", dateType: "ontype",isRequired:true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Kyc Desc",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "kyc_desc",isRequired:true,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Risk Category",star:true}),
...controls.oc({ tab: "general", c: "RiskCategory", placeHolder: "Risk Category Code", name: "risk_category_code", isRequired:true,fastpath:"risk_categories"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "risk_category_display"}),
...controls.displayText({ tab: "general", label: "Customer Category",star:true}),
...controls.oc({ tab: "general", c: "CustomerCategory", placeHolder: "Customer Category Code", name: "customer_category_code", isRequired:true,fastpath:"customer_categories" ,isReadOnly:"edit" }),
...controls.showData({ tab: "general", displaytype: "capital", data: "customer_category_display"}),
...controls.checkBox({ tab: "general", label: "Kyc Flag",default:false, name: "kyc_flag" }),
]
,history:{
perPage: 10,
reportHeader: "Customer Kpis",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Kyc Due Date",accessor: "kyc_due_date",type:'date'},
{Header: "Kyc Flag",accessor: "kyc_flag",type:'tick'},
{Header: "Kyc Desc",accessor: "kyc_desc",},
{Header: "Risk Category Id",accessor: "risk_category_id",},
{Header: "Customer Category Id",accessor: "customer_category_id",},
{Header: "Sign Flag",accessor: "sign_flag",type:'tick'},
{Header: "Sign Date",accessor: "sign_date",type:'date'},
{Header: "Sign Count",accessor: "sign_count",},
]}};
export default customer_kpis;